export const contentDict = {
  title: "Recent Adaptations of Neural Radiance Fields (NeRF)",                // Display name
  finishDate: new Date("2023-10-10"),     // format is YYYY-MM-DD
  description: 
    `Overview on applications and downstream tasks of NeRF that enable generalization, video synthesis, 
    stochastic 3D completion, etc.`,
  tags: ["ML", "Computer Vision", "NeRF"],
  authors: ["Philipp Wulff"],
  coverImage: require('./Imgs/nerf_input_output.png'),
  markdownFile: require('./post.md'),
  parentDirName: "nerf_applications",    
  citations: require('./citations.bib'),
  hidden: false,
};

export default contentDict;